import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Play,
    Video,
    ExternalLink,
    ChevronLeft,
    ChevronRight,
    Building,
    Globe,
    Link2,
    Sparkles
} from 'lucide-react';

function LinkTerkait() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [videos] = useState([
        { id: 1, src: "https://www.youtube.com/embed/QuhlDnGYgKY?si=76bt2eKEK1msEUaS", title: "Video 1" },
        { id: 2, src: "https://www.youtube.com/embed/Q0myiILxxnU?si=cAFzRpNeM2TVD4TT", title: "Video 2" },
        { id: 3, src: "https://www.youtube.com/embed/XXXXXXXX", title: "Video 3" },
        { id: 4, src: "https://www.youtube.com/embed/XXXXXXXX", title: "Video 4" },
        { id: 5, src: "https://www.youtube.com/embed/XXXXXXXX", title: "Video 5" },
    ]);

    const [relatedLinks] = useState([
        {
            id: 1,
            title: "PEMKOT MAGELANG",
            url: "https://magelangkota.go.id/page/profil-kota-magelang-2",
            image: "https://magelangkota.go.id/lambang-header-desktop.svg",
            description: "Portal Resmi Pemerintah Kota Magelang"
        },
        {
            id: 2,
            title: "SIABAH MAGELANG KOTA",
            url: "https://siabah.magelangkota.go.id",
            image: "https://siabah.magelangkota.go.id/assets/2024/images/logoedit3.png",
            description: "Sistem Informasi Administrasi Kependudukan"
        },
        {
            id: 3,
            title: "JDIH PROVINSI JAWA TENGAH",
            url: "https://jdih.jatengprov.go.id/",
            image: "https://jdih.jatengprov.go.id/media/logo.webp",
            description: "Jaringan Dokumentasi dan Informasi Hukum"
        }
    ]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % Math.ceil(videos.length / 3));
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + Math.ceil(videos.length / 3)) % Math.ceil(videos.length / 3));
    };

    // Get visible videos (3 at a time)
    const getVisibleVideos = () => {
        const start = currentSlide * 3;
        const end = start + 3;
        return videos.slice(start, end);
    };

    return (
        <div className="w-full bg-gradient-to-b from-blue-50 via-white to-purple-50 py-12 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Video Section */}
                <div className="mb-16">
                    <div className="text-center mb-8">
                        <div className="flex items-center justify-center gap-3 mb-3">
                            <Video className="w-8 h-8 text-[#0889c1]" />
                            <h2 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: 'MuseoSansRounded900' }}>
                                <span className="text-[#0889c1]">VIDEO</span>
                                <span className="text-gray-700"> SEPUTAR JDIH</span>
                            </h2>
                        </div>
                        <div className="w-24 h-1 bg-gradient-to-r from-[#0889c1] to-purple-500 mx-auto rounded-full"></div>
                        <p className="mt-3 text-gray-600 text-sm">
                            Tonton video-video terkini seputar JDIH Kota Magelang
                        </p>
                    </div>

                    {/* Video Carousel */}
                    <div className="relative">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {getVisibleVideos().map((video) => (
                                <div
                                    key={video.id}
                                    className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                                >
                                    <div className="relative">
                                        <iframe
                                            className="w-full h-48 md:h-56 lg:h-64"
                                            src={video.src}
                                            allowFullScreen
                                            title={video.title}
                                            loading="lazy"
                                        ></iframe>
                                        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                                            <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                                                <Play className="w-8 h-8 text-[#0889c1] ml-1" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-4">
                                        <h4 className="text-sm font-semibold text-gray-800 group-hover:text-[#0889c1] transition-colors duration-200">
                                            {video.title}
                                        </h4>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Navigation Arrows */}
                        {videos.length > 3 && (
                            <>
                                <button
                                    onClick={prevSlide}
                                    className="absolute -left-4 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:bg-[#0889c1] hover:text-white group"
                                    aria-label="Previous video"
                                >
                                    <ChevronLeft className="w-5 h-5 group-hover:text-white" />
                                </button>
                                <button
                                    onClick={nextSlide}
                                    className="absolute -right-4 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 shadow-lg hover:shadow-xl transition-all duration-200 hover:bg-[#0889c1] hover:text-white group"
                                    aria-label="Next video"
                                >
                                    <ChevronRight className="w-5 h-5 group-hover:text-white" />
                                </button>
                            </>
                        )}
                    </div>

                    {/* Video Indicators */}
                    {videos.length > 3 && (
                        <div className="flex justify-center gap-2 mt-6">
                            {Array.from({ length: Math.ceil(videos.length / 3) }).map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentSlide(index)}
                                    className={`w-2 h-2 rounded-full transition-all duration-300 ${currentSlide === index
                                            ? 'w-8 bg-[#0889c1]'
                                            : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    )}
                </div>

                {/* Banner Section */}
                <div className="relative">
                    {/* Decorative Background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-[#0889c1]/5 to-purple-500/5 rounded-3xl -z-10"></div>

                    <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-xl">
                        <div className="text-center mb-8">
                            <div className="flex items-center justify-center gap-3 mb-3">
                                <Link2 className="w-8 h-8 text-[#0889c1]" />
                                <h2 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: 'MuseoSansRounded900' }}>
                                    <span className="text-[#0889c1]">BANNER</span>
                                    <span className="text-gray-700"> SITUS TERKAIT</span>
                                </h2>
                            </div>
                            <div className="w-24 h-1 bg-gradient-to-r from-[#0889c1] to-purple-500 mx-auto rounded-full"></div>
                            <p className="mt-3 text-gray-600 text-sm">
                                Akses cepat ke situs-situs terkait JDIH Kota Magelang
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {relatedLinks.map((link) => (
                                <a
                                    key={link.id}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="group block bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105"
                                >
                                    <div className="relative h-48 overflow-hidden bg-gray-50 flex items-center justify-center p-4">
                                        <img
                                            src={link.image}
                                            alt={link.title}
                                            className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-110"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%23e5e7eb"/%3E%3Ctext x="50" y="110" font-family="Arial" font-size="16" fill="%236b7280" text-anchor="middle"%3ELogo%3C/text%3E%3C/svg%3E';
                                            }}
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    </div>
                                    <div className="p-5">
                                        <div className="flex items-start justify-between mb-2">
                                            <h3 className="text-sm font-bold text-gray-800 group-hover:text-[#0889c1] transition-colors duration-200 flex-1">
                                                {link.title}
                                            </h3>
                                            <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-[#0889c1] transition-colors duration-200 flex-shrink-0 ml-2" />
                                        </div>
                                        {link.description && (
                                            <p className="text-xs text-gray-500">{link.description}</p>
                                        )}
                                        <div className="mt-3 flex items-center text-[#0889c1] text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <span>Kunjungi Situs</span>
                                            <ChevronRight className="w-3 h-3 ml-1 transform group-hover:translate-x-1 transition-transform duration-200" />
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Decorative Element */}
                <div className="mt-12 text-center">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#0889c1]/10 to-purple-500/10 rounded-full">
                        <Sparkles className="w-4 h-4 text-[#0889c1]" />
                        <span className="text-xs font-medium text-gray-600">
                            JDIH Kota Magelang - Informasi Hukum Terpercaya
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LinkTerkait;